import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import API from '../utils/api';
import toast from 'react-hot-toast';
import { Mail, ArrowLeft, MailCheck } from 'lucide-react';
import { useSiteSettings } from '../context/SiteSettingsContext';
import useSEO from '../hooks/useSEO';
import './AuthPage.css';

export default function ForgotPasswordPage() {
  const { settings } = useSiteSettings();
  const sn = settings.siteName;
  useSEO({ title: 'Lupa Sandi', siteName: sn, noindex: true });
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Gagal mengirim. Coba lagi.');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-root">
      <div className="auth-body">
        <div className="auth-card">
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <h1 className="auth-title">{sn}</h1>
            <p className="auth-subtitle">Pulihkan akses akun Anda</p>
          </div>

          {sent ? (
            <div style={{ textAlign: 'center', padding: '12px 0' }}>
              <MailCheck size={44} style={{ color: 'var(--in-blue)', margin: '0 auto 14px' }} />
              <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Cek Email Anda</h2>
              <p style={{ fontSize: 14, color: 'var(--in-text-muted)', lineHeight: 1.6, marginBottom: 20 }}>
                Jika email <strong>{email}</strong> terdaftar, kami telah mengirim link untuk mereset kata sandi. Link berlaku 1 jam.
              </p>
              <Link to="/login" className="btn btn-secondary btn-full">Kembali ke Masuk</Link>
            </div>
          ) : (
            <>
              <p style={{ fontSize: 14, color: 'var(--in-text-muted)', marginBottom: 18, lineHeight: 1.6 }}>
                Masukkan email akun Anda. Kami akan mengirim link untuk membuat kata sandi baru.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <div className="input-icon-wrap">
                    <Mail size={15} className="input-icon" />
                    <input type="email" className="form-input input-with-icon" value={email}
                      onChange={e => setEmail(e.target.value)} placeholder="email@domain.com" required autoFocus />
                  </div>
                </div>
                <button type="submit" className="btn btn-primary btn-full btn-lg" disabled={loading}>
                  {loading ? 'Mengirim...' : 'Kirim Link Reset'}
                </button>
              </form>
              <p className="auth-footer-text" style={{ marginTop: 18 }}>
                <Link to="/login" className="auth-link" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                  <ArrowLeft size={14} /> Kembali ke Masuk
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
